
  export const PROPS_RECEIVED = "PROPS_RECEIVED";
  export const SET_PROP = "SET_PROP";
  export const CREATE_PROP = "CREATE_PROP";
  export const SET_PROPERTY_PROP = "SET_PROPERTY_PROP";
  